


























































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { mapState } from 'vuex';
import moment from 'moment-timezone';
import VueMonthlyPicker from 'vue-monthly-picker';
import { Spinner } from 'vue-image-spinner2';
import FeedbackInvoicePDVModal from '../modals/FeedbackInvoicePDVModal.vue'; // ✅ Importación correcta


@Component({
  name: 'feedback-invoices-pdv',
  components: {
    VueMonthlyPicker,
    Spinner,
    'feedback-invoice-pdv-modal': FeedbackInvoicePDVModal
  },
  filters: {
    date(val: any) {
      return val == null ? 'Rango de fecha' : moment(val).format('YYYY/MM/DD');
    },
  },
  computed: {
    ...mapState('feedbackInvoicesPDV', [
      'allFeedbackInvoicesPDV',
      'allFeedbackInvoicesPDVLoading',
      'invoiceFeedbacksPDVPerPage',
      'invoiceFeedbacksPDVPage',
      'invoiceFeedbacksPDVTotal',
      'activeFeedbackInvoicePDV',
    ]),
    ...mapState('auth', ['currentUser']),

  },
})
export default class FeedbackInvoicesPDV extends Vue {
  public allFeedbackInvoicesPDV!: any[];
  public allFeedbackInvoicesPDVLoading!: boolean;
  public invoiceFeedbacksPDVPerPage!: number;
  public invoiceFeedbacksPDVPage!: number;
  public invoiceFeedbacksPDVTotal!: number;
  public activeFeedbackInvoicePDV!: any;
   private currentUser!: any;

  public invoice_feedbackPDV_word_search: string = '';
  public dateRange: any = { startDate: null, endDate: null };
  public singleDatePicker: any = 'range';
  public allFeedbackInvoicesPDVHeaders = [
    { thClass: 'th', key: 'pdv_order', label: 'Venta' },
    { thClass: 'th', key: 'date_created', label: 'Fecha' },
    { thClass: 'th', key: 'status', label: 'Estatus' },
    { thClass: 'th', key: 'edit', label: '' },

  ];

  setUrlSearch(search: string) {
    search = search.trim();
    this.$router.push({
      path: 'feedback-invoices-pdv',
      query: { ...this.$route.query, search },
    });
  }

  async onOpenFeedbackInvoicePDVModal(id: string | null = null) {
    try {
      await this.$store.dispatch('feedbackInvoicesPDV/getOne', id);
      this.$bvModal.show('feedback-invoice-pdv-modal');
      
    } catch (error) {
      console.error('❌ Error:', error);
    }
  }

  onPageChange(page: number) {
    this.$router.push({
        path: 'feedback-invoices-pdv',
        query: { ...this.$route.query, page: page.toString() }
    })
  }


  onFilterDateRange() {
    const start_date = moment(this.dateRange.startDate).format('YYYY/MM/DD');
    const end_date = moment(this.dateRange.endDate).add(1, 'd').format('YYYY/MM/DD');
    this.$router.push({
      path: 'feedback-invoices-pdv',
      query: { ...this.$route.query, start_date, end_date },
    });
  }

  clearFilters() {
    this.invoice_feedbackPDV_word_search = '';
    this.dateRange = { startDate: null, endDate: null };
    this.$router.push({ path: 'feedback-invoices-pdv', query: {} });
  }

  @Watch('$route')
  getAllInvoices() {
    const page = this.$route.query.page || 1;
    const search = this.$route.query.search || null;
    const status_filter = this.$route.query.status_filter || null;
    const start_date = this.$route.query.start_date || null;
    const end_date = this.$route.query.end_date || null;

    this.$store.dispatch('feedbackInvoicesPDV/getAll', {
      page,
      search,
      status_filter,
      start_date,
      end_date,
    });

    // console.log(items[0].status);

  }

  mounted() {
    this.getAllInvoices();
  }
}
